export default __webpack_public_path__ + "3ac19ce1ed64e3ea0ce3847e229730ce.png";